import { Center, Img } from '@chakra-ui/react'

import CourseQ from '@/queries/CourseQ'
import SeriesQ from '@/queries/SeriesQ'
import SeriesTemplateQ from '@/queries/SeriesTemplateQ'
import type { Query } from '@/client/query'
import { PROGRAM_SLUG_TO_PROGRAM_ITERATIONS } from '@/client/services/programs/config'

import { COURSE_SLUG_TO_SERIES_ICON_URL } from './constants'

export default function SeriesIcon({ series }: { series: Query }) {
  const course = series.one(SeriesQ.getCourse())
  const seriesCourseSlug = course(CourseQ.slug) ?? ''

  const seriesTemplate = series.one(SeriesQ.getSeriesTemplate())
  const seriesTemplateSlug = seriesTemplate(SeriesTemplateQ.slug)

  const programOffering = Object.values(PROGRAM_SLUG_TO_PROGRAM_ITERATIONS)
    .flat()
    .flatMap(iteration => iteration.offerings)
    .find(offering => offering.seriesTemplateSlug === seriesTemplateSlug)

  const src: string | null =
    COURSE_SLUG_TO_SERIES_ICON_URL[seriesCourseSlug] ??
    (programOffering != null ? programOffering.offeringTemplate.imageUrl : null) ??
    null

  return src != null ? (
    <Center w="60px" h="60px">
      <Img h="55px" src={src} objectFit="contain" />
    </Center>
  ) : null
}
